import { render, staticRenderFns } from "./SearchbarInCategoryButtons.vue?vue&type=template&id=2e0aafed&scoped=true&"
import script from "./SearchbarInCategoryButtons.vue?vue&type=script&lang=ts&"
export * from "./SearchbarInCategoryButtons.vue?vue&type=script&lang=ts&"
import style0 from "./SearchbarInCategoryButtons.vue?vue&type=style&index=0&id=2e0aafed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0aafed",
  null
  
)

export default component.exports